import axios from 'axios'
import errorCode from '@/utils/errorCode'
import { getAuthorizationToken } from '@/utils/auth'
import cache from '@/plugins/cache'
import { tansParams } from "@/utils/common";
import { Notification, Message } from 'element-ui'
import store from '@/store'
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || '/api', // 从环境变量读取基础地址，默认为 /api

    timeout: 15000 // 请求超时时间
})
export let isRelogin = { show: false };
service.interceptors.request.use(config => {
    // console.log(process.env.VUE_APP_BASE_API);

    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
        // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    const authorizationToken = getAuthorizationToken()
    if (authorizationToken && !isToken) {
        config.headers['Authorization'] = authorizationToken
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
        const requestObj = {
            url: config.url,
            data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
            time: new Date().getTime()
        }
        const sessionObj = cache.session.getJSON('sessionObj')
        if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
            cache.session.setJSON('sessionObj', requestObj)
        } else {
            const s_url = sessionObj.url; // 请求地址
            const s_data = sessionObj.data; // 请求数据
            const s_time = sessionObj.time; // 请求时间
            const interval = 100; // 间隔时间(ms)，小于此时间视为重复提交
            if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
                const message = '数据正在处理，请勿重复提交';
                console.warn(`[${s_url}]: ` + message)
                return Promise.reject(new Error(message))
            } else {
                cache.session.setJSON('sessionObj', requestObj)
            }
        }
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode['default']
            // 二进制数据则直接返回
        if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
            return res.data
        }
        if (code === 401) {

            // MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
            //     confirmButtonText: '重新登录',
            //     cancelButtonText: '取消',
            //     type: 'warning',
            //     customClass: 'el-zi2000'
            // }).then(() => {
            //     location.href = '/index';
            //     store.state.showLogin = true
            //     store.dispatch('FedLogOut')
            // }).catch(() => {

            // });
            location.href = '/';
            store.dispatch('FedLogOut')
            console.log(656);

            return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
        } else if (code === 500) {
            // Message({
            //     message: msg,
            //     type: 'error'
            // })
            // return Promise.reject(new Error(msg))
            return res.data
        } else if (code === 601) {
            Message({
                message: msg,
                type: 'warning'
            })
            return Promise.reject('error')
        } else if (code !== 200) {
            Notification.error({
                title: msg
            })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        console.log('err' + error)
        let {
            message
        } = error;
        if (message == "Network Error") {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
